pageId = 'page-member-settings-two-factor-auth'
page = "##{ pageId }"

$ ->
  tower.stack.on "pageunload", (e, $page, pageParams) ->
    if $page.is(page)
      tower.tempPusherSocket?.disconnect?()
      tower.tempPusherSocket = null

    return e.result


$(document).on "pjaxload##{ pageId }", (e, $page, page) ->
  fetchQrcode()


fetchQrcode = ->
  $.ajax
    url: '/wechat/qrcode/?type=1'
    type: 'get'
    dataType: 'json'
    success: (result) ->
      if result.success
        $('img.qrcode').attr('src', result.qrcode_url)
        channel = tower.tempPusher(result.channel)

        channel.bind 'pusher:subscription_succeeded', ->
          $('.qrcode-wrap').removeClass('loading').find('.indicator').remove()
        .bind 'WECHAT_BIND', (result) ->
          unless result.success
            simple.dialog.message
              content: result.message
            return

          tower.stack.load( $('#success-url').val(), {
            replace: true
          })
